// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-layout-header {
  height: 70px;
  padding: 0 25px;
  background-color: #012969;
}
.ant-layout-header .ant-row {
  height: 100%;
}
.ant-layout-header .ant-row .headerLogo {
  display: flex;
  align-items: center;
  height: 100%;
}
.ant-layout-header .ant-row .headerLogo img {
  width: auto;
  height: auto;
}
.ant-layout-header .menuWrapper {
  display: flex;
  align-items: center;
  height: 100%;
  gap: 30px;
}
.ant-layout-header .menuWrapper .ant-menu-overflow-item::after {
  content: unset;
}
.ant-layout-header .menuWrapper .ant-menu-light {
  background-color: #012969;
}
.ant-layout-header .menuWrapper .ant-menu-light span {
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  opacity: 0.5;
}
.ant-layout-header .menuWrapper .ant-menu-item-selected span {
  opacity: 1;
}
.mobileHeaderWrapper {
  display: none;
}
@media (max-width: 991px) {
  .ant-layout-header {
    display: none;
  }
  .mobileHeaderWrapper {
    display: block;
  }
  .mobileHeaderWrapper .mobileMenuTop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 20px;
    background-color: #012969;
  }
  .mobileHeaderWrapper .mobileMenuTop button {
    padding: 10px !important;
    border-radius: 4px !important;
  }
  .mobileHeaderWrapper .headerMenu {
    right: -300px;
    position: fixed;
    transition: 0.5s;
    width: 300px;
    height: 100vh;
    z-index: 10;
    top: 0;
    background-color: #ffffff;
  }
  .mobileHeaderWrapper .headerMenu .mobileMenuTop {
    padding: 10px;
    display: flex;
    justify-content: flex-end;
    background-color: #ffffff;
  }
  .mobileHeaderWrapper .headerMenu ul li {
    border-top: 1px solid #012969;
    border-radius: 0;
    margin-top: 0;
    margin-bottom: 0;
  }
  .mobileHeaderWrapper .headerMenu ul li span {
    font-size: 14px;
    color: #012969;
  }
  .mobileHeaderWrapper .headerMenu ul .ant-menu-item-selected {
    background-color: #012969;
  }
  .mobileHeaderWrapper .headerMenu ul .ant-menu-item-selected span {
    color: #ffffff;
  }
  .mobileHeaderWrapper .open {
    right: 0px;
    box-shadow: 0px 0px 10px #0000000f;
  }
}
@media (min-width: 481px) and (max-width: 767px) {
  .headerWrapper {
    padding: 10px 45px 0px !important;
  }
  .headerWrapper.ant-layout-header h1.page-title {
    font-size: 20px !important;
  }
}
@media (min-width: 280px) and (max-width: 480px) {
  .headerWrapper {
    padding: 10px 45px 0px !important;
    height: 55px;
  }
  .headerWrapper.ant-layout-header h1.page-title {
    font-size: 14px !important;
  }
  .headerWrapper .userProfileWrapper {
    display: grid;
    gap: 10px;
  }
  .headerWrapper .userProfileWrapper .ant-badge svg {
    height: 25px;
    width: 29px;
  }
  .headerWrapper .userProfileWrapper .cont {
    gap: 10px;
  }
  .headerWrapper .userProfileWrapper .cont .profileImageWrapper {
    height: 28px;
    width: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .headerWrapper .userProfileWrapper .cont p {
    font-size: 14px;
  }
  .headerWrapper .left {
    display: grid;
    grid-template-columns: 38px auto;
    gap: 10px;
  }
  .headerWrapper .left .img {
    height: 36px;
    width: 36px;
  }
  .ant-popover-title {
    font-size: 16px;
    min-width: unset !important;
  }
  .notificationWrapper {
    width: 260px;
  }
  .notificationWrapper .cont {
    grid-template-columns: 50px 1fr;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .notificationWrapper .cont .mid h4 {
    font-size: 16px;
  }
  .notificationWrapper .cont .mid p {
    font-size: 12px;
    line-height: 1.2;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layout/TopHeader/Header.less"],"names":[],"mappings":"AAEA;EAEE,YAAA;EACA,eAAA;EACA,yBAAA;AAFF;AAFA;EAMI,YAAA;AADJ;AALA;EAQM,aAAA;EACA,mBAAA;EACA,YAAA;AAAN;AAVA;EAYQ,WAAA;EACA,YAAA;AACR;AAdA;EAkBI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;AADJ;AAGM;EACE,cAAA;AADR;AAvBA;EA4BM,yBAAA;AAFN;AA1BA;EA8BQ,cAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AADR;AAhCA;EAwCQ,UAAA;AALR;AAWA;EACE,aAAA;AATF;AAoCA;EACE;IACE,aAAA;EAlCF;EAoCA;IACE,cAAA;EAlCF;EAiCA;IAGI,aAAA;IACF,mBAAA;IACA,8BAAA;IACA,kBAAA;IACA,yBAAA;EAjCF;EA0BA;IASI,wBAAA;IACA,6BAAA;EAhCJ;EAsBA;IAcI,aAAA;IACA,eAAA;IACA,gBAAA;IACA,YAAA;IACA,aAAA;IACA,WAAA;IACA,MAAA;IACA,yBAAA;EAjCJ;EAYA;IAuBM,aAAA;IACA,aAAA;IACA,yBAAA;IACA,yBAAA;EAhCN;EAMA;IA8BQ,6BAAA;IACA,gBAAA;IACA,aAAA;IACA,gBAAA;EAjCR;EAAA;IAmCU,eAAA;IACA,cAAA;EAhCV;EAJA;IAwCQ,yBAAA;EAjCR;EAPA;IA0CU,cAAA;EAhCV;EAVA;IAgDI,UAAA;IACA,kCAAA;EAnCJ;AACF;AAyCA;EACE;IACE,iCAAA;EAvCF;EAwCE;IAEI,0BAAA;EAvCN;AACF;AA8CA;EACE;IACE,iCAAA;IACA,YAAA;EA5CF;EA6CE;IAEI,0BAAA;EA5CN;EAuCA;IAUI,aAAA;IAEA,SAAA;EA/CJ;EAmCA;IAeQ,YAAA;IACA,WAAA;EA/CR;EA+BA;IAoBM,SAAA;EAhDN;EA4BA;IAsBQ,YAAA;IACA,WAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EA/CR;EAqBA;IA6BQ,eAAA;EA/CR;EAkBA;IAmCI,aAAA;IACA,gCAAA;IACA,SAAA;EAlDJ;EAaA;IAyCM,YAAA;IACA,WAAA;EAnDN;EA0DA;IACE,eAAA;IACA,2BAAA;EAxDF;EA2DA;IACE,YAAA;EAzDF;EAwDA;IAGI,+BAAA;IACA,iBAAA;IACA,oBAAA;EAxDJ;EAmDA;IAQQ,eAAA;EAxDR;EAgDA;IAWQ,eAAA;IACA,gBAAA;EAxDR;AACF","sourcesContent":["@import url(\"../../assets/Styles/variables.less\");\n\n.ant-layout-header {\n  \n  height: 70px;\n  padding: 0 25px;\n  background-color: @ghl-color;\n  .ant-row {\n    height: 100%;\n    .headerLogo{\n      display: flex;\n      align-items: center;\n      height: 100%;\n      img{\n        width: auto;\n        height: auto;\n      }\n    }\n  }\n  .menuWrapper {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    gap: 30px;\n    .ant-menu-overflow-item{\n      &::after{\n        content: unset;\n      }\n    }\n    .ant-menu-light {\n      background-color: @ghl-color;\n      span {\n        color: @white-color;\n        font-size: 14px;\n        font-weight: 500;\n        opacity: .5;\n\n      }\n      \n    }\n    .ant-menu-item-selected{\n      span{\n        opacity: 1;\n      }\n      \n    }\n  }\n}\n.mobileHeaderWrapper{\n  display: none;\n}\n\n// MEDIA QUERY START\n\n// ##Device = HD Desktops\n// ##Screen = 1600px to higher resolution desktops\n\n@media screen and (min-width: 1600px) {\n} //  Dont delete this bracket!\n\n// ##Device = Desktops\n// ##Screen = 1281px to higher resolution desktops\n@media (min-width: 1281px) and (max-width: 1599px) {\n} //  Dont delete this bracket!\n\n// ##Device = Laptops, Desktops\n// ##Screen = B/w 1025px to 1280px\n@media (min-width: 1025px) and (max-width: 1280px) {\n} //  1025px to 1280px (Laptops, Desktops) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (landscape)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n} //  768px to 1024px (landscape) Dont delete this bracket!\n\n\n@media (max-width: 991px) {\n  .ant-layout-header{\n    display: none;\n  }\n  .mobileHeaderWrapper{\n    display: block;\n    .mobileMenuTop{\n      display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 15px 20px;\n    background-color: @ghl-color;\n    button{\n      padding: 10px !important;\n      border-radius: 4px !important;\n    }\n    }\n    .headerMenu {\n      right: -300px;\n      position: fixed;\n      transition: 0.5s;\n      width: 300px;\n      height: 100vh;\n      z-index: 10;\n      top: 0;\n      background-color: @white-color;\n      .mobileMenuTop{\n        padding: 10px;\n        display: flex;\n        justify-content: flex-end;\n        background-color: @white-color;\n      }\n      ul{\n        li{\n          border-top: 1px solid @ghl-color;\n          border-radius: 0;\n          margin-top: 0;\n          margin-bottom: 0;\n          span{\n            font-size: 14px;\n            color: @ghl-color;\n          }\n        }\n        .ant-menu-item-selected{\n          background-color: @ghl-color;\n          span{\n            color: @white-color;\n          }\n        }\n      }\n    }\n    .open{\n      right: 0px;\n      box-shadow: 0px 0px 10px @box-shadow-color;\n    }\n  }\n} \n\n// ##Device = Low Resolution Tablets, Mobiles (Landscape)\n// ##Screen = B/w 481px to 767px\n@media (min-width: 481px) and (max-width: 767px) {\n  .headerWrapper {\n    padding: 10px 45px 0px !important;\n    &.ant-layout-header {\n      h1.page-title {\n        font-size: 20px !important;\n      }\n    }\n  }\n} //  481px to 767px (Landscape) Dont delete this bracket!\n\n// ##Device = Most of the Smartphones Mobiles (Portrait)\n// ##Screen = B/w 280px to 480px\n@media (min-width: 280px) and (max-width: 480px) {\n  .headerWrapper {\n    padding: 10px 45px 0px !important;\n    height: 55px;\n    &.ant-layout-header {\n      h1.page-title {\n        font-size: 14px !important;\n      }\n    }\n\n    .userProfileWrapper {\n      display: grid;\n      // grid-template-columns: 45px 1fr;\n      gap: 10px;\n      .ant-badge {\n        svg {\n          height: 25px;\n          width: 29px;\n        }\n      }\n      .cont {\n        gap: 10px;\n        .profileImageWrapper {\n          height: 28px;\n          width: 28px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n        p {\n          font-size: 14px;\n        }\n      }\n    }\n\n    .left {\n      display: grid;\n      grid-template-columns: 38px auto;\n      gap: 10px;\n      .ant-space {\n      }\n      .img {\n        height: 36px;\n        width: 36px;\n        img {\n        }\n      }\n    }\n  }\n\n  .ant-popover-title {\n    font-size: 16px;\n    min-width: unset !important;\n  }\n\n  .notificationWrapper {\n    width: 260px;\n    .cont {\n      grid-template-columns: 50px 1fr;\n      padding-top: 10px;\n      padding-bottom: 10px;\n      .mid {\n        h4 {\n          font-size: 16px;\n        }\n        p {\n          font-size: 12px;\n          line-height: 1.2;\n        }\n      }\n    }\n  }\n} //  280px to 480px (Portrait) Dont delete this bracket!\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
